import React, { memo } from 'react';
import classNames from 'classnames/bind';
import styles from './ErrorButton.scss';
const cx = classNames.bind(styles);
const ErrorButton = memo(({ errorCount, onClick }) => (React.createElement("button", { className: cx('base'), onClick: onClick },
    "X",
    errorCount > 0 && React.createElement("div", { className: cx('badge') }, errorCount))));
export default ErrorButton;
